<template>
    <li class="admin-item__container">
        <div class="admin-item__icon">
            <template v-if="icon === 'belgium'">
                <SvgIcon icon="belgium" />
            </template>
            <template v-else-if="icon">
                <FaLightIcon :icon-name="icon" />
            </template>
        </div>
        <dl class="admin-item__details">
            <div>
                <dt>{{ $t('admin.name') }}</dt>
                <dd>{{ id }}</dd>
            </div>
            <div>
                <dt>{{ $t('admin.translation') }}</dt>
                <dd>{{ name }}</dd>
            </div>
            <div>
                <dt>{{ $t('admin.signbankid') }}</dt>
                <dd>{{ signBankIdsDisplay }}</dd>
            </div>
            <div v-if="info">
                <dt>{{ $t('admin.infotext') }}</dt>
                <dd>{{ info }}</dd>
            </div>
        </dl>
        <div class="admin-item__actions">
            <Button
                @click="editItem"
                :icon="['fal', 'pencil']"
                :is-icon-button="true"
                :label="$t('admin.edit')"
                variant="secondary"
            />
            <Button
                @click="deleteItem"
                :icon="['fal', 'trash']"
                :is-icon-button="true"
                :label="$t('admin.delete')"
                variant="secondary"
            />
        </div>
    </li>
</template>
<script lang="ts">
import Vue from 'vue';
import { Component, Emit, Prop } from 'vue-property-decorator';
import SvgIcon from '@/components/SvgIcon.vue';
import FaLightIcon from '@/components/general/FaLightIcon.vue';
import Button from '../general/Button.vue';

@Component({ components: { SvgIcon, FaLightIcon, Button } })
export default class AdminItem extends Vue {
    @Prop()
    private icon: string;

    @Prop()
    private id: string;

    @Prop()
    private name: string;

    @Prop()
    private signBankIds: number[];

    @Prop()
    private signBankId: string; // Backward compatibility

    @Prop()
    private info?: string;

    get signBankIdsDisplay(): string {
        if (this.signBankIds && this.signBankIds.length > 0) {
            return this.signBankIds.join(', ');
        }
        // Backward compatibility for old single signBankId
        return this.signBankId || '';
    }

    @Emit()
    public editItem() {}

    @Emit()
    public deleteItem() {}
}
</script>

<style lang="scss" scoped>
.admin-item__container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 1.5rem;
    padding: 1.5rem 0;
    width: 100%;

    &:not(:last-child) {
        border-bottom: $divider;
    }
}

.admin-item__actions {
    display: flex;
    gap: 0.5rem;
}

.admin-item__icon {
    --icon-size: 3rem;

    display: flex;
    place-items: center;
    flex-basis: var(--icon-size);
    flex-grow: 1;
    flex-shrink: 0;
    color: var(--text-secondary-color);
    height: var(--icon-size);
    width: var(--icon-size);

    svg {
        width: 100%;
        height: 100%;
    }
}

.admin-item__details {
    width: 100%;
    display: grid;
    grid-template-columns: auto 1fr;

    div {
        display: grid;
        gap: 1ch;
        grid-column: 1/-1;
        grid-template-columns: subgrid;
    }

    dt {
        font-family: $font-family-accent;
        font-weight: bold;
    }

    dd {
        margin: 0;
    }
}
</style>
